import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FolderFormDataObjectDepre } from '@it2go/types';
import { TableColumn } from '../../../../../shared/components/kit/table/table.types';
import { dateField, userChipColumn } from '../../../../../shared/components/kit/table/table.fields';

@Component({
    template: '',
})
export abstract class FormBaseTableComponent implements OnChanges {
    @Input() items: FolderFormDataObjectDepre[] = [];
    @Input({ required: true })
    resource!: string;
    @Output() editFormData = new EventEmitter<FolderFormDataObjectDepre>();
    @Output() printFormData = new EventEmitter<FolderFormDataObjectDepre>();
    @Output() copyFormData = new EventEmitter<FolderFormDataObjectDepre>();
    @Output() deleteFormData = new EventEmitter<FolderFormDataObjectDepre>();

    protected itemsWithJsonData: FolderFormDataObjectDepre[] = [];
    protected columnsStart: TableColumn[] = [
        { name: 'print' },
        { name: 'copy' },
        dateField('date', false, false),
    ];
    protected columnsEnd: TableColumn[] = [
        userChipColumn,
    ];
    protected columns: TableColumn[] = [];

    ngOnChanges() {
        this.itemsWithJsonData = this.items.map((item) => {
            return {
                ...item,
                data: JSON.parse(item.data),
            };
        });
    }

    protected generateColumns(uniqueColumns: string[]) {
        this.columns = [
            ...this.columnsStart,
            ...(uniqueColumns.map((col) => ({ name: col }))),
            { name: 'note', dataKey: 'data.note' },
            ...this.columnsEnd,
        ];
    }

    protected detail(formData: FolderFormDataObjectDepre) {
        this.editFormData.emit(formData);
    }

    protected print(formData: FolderFormDataObjectDepre) {
        this.printFormData.emit(formData);
    }

    protected copy(formData: FolderFormDataObjectDepre) {
        this.copyFormData.emit(formData);
    }

    protected delete(formData: any) {
        this.deleteFormData.emit(formData);
    }

    protected readonly JSON = JSON;
}
